import { render, staticRenderFns } from "./ActionCancelPortingProcess.vue?vue&type=template&id=570fab15&scoped=true&"
import script from "./ActionCancelPortingProcess.vue?vue&type=script&lang=js&"
export * from "./ActionCancelPortingProcess.vue?vue&type=script&lang=js&"
import style0 from "./ActionCancelPortingProcess.vue?vue&type=style&index=0&id=570fab15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570fab15",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VTextarea})
